<template>
  <b-modal
    centered
    hide-footer
    hide-header
    modal-class="modal fade lg entity-modal"
    id="not-travel-agent-modal"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content mx-3">
        <div class="modal-body">
          <div class="modal-body__header">
            <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('not-travel-agent-modal')">
              <span></span>
              <span></span>
            </button>
          </div>
          <div class="modal-body--alert">
            <i class="icon-only-professional-rate md"></i>
            <strong class="modal-body__title" data-testid="modal-title">
              {{ translate('rdProfesionalRateSelectedTitle') }}
            </strong>
            <div :class="buttonText === 'LOG IN' ? 'modal-body__subtitle non-login-subtitle' : 'modal-body__subtitle'" data-testid="modal-content">
              {{ content }}
            </div>
            <button
              aria-label="close modal"
              data-toggle="modal"
              data-target="#modal-rewards-login"
              class="btn btn-primary modal-btn text-light text-uppercase"
              data-testid="modal-back-btn"
              id="modal-back-btn"
              @click="$bvModal.hide('not-travel-agent-modal')"
            >
              <span>
                {{ buttonText }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'NotTravelAgentModal',
  props: {
    content: {
      type: String
    },
    buttonText: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
#not-travel-agent-modal {
  .modal-body {
    &__header {
      button {
        z-index: 10;
        top: 2.5rem;
        right: 2.5rem;
        span {
          background: #000000;
          height: 0.2rem;
          width: 2.4rem;
        }
        span + span {
          top: -2px;
        }
      }
    }
    &__title {
      color: #242424;
      font-size: 2.4rem;
      margin-top: 3rem !important;
      margin-bottom: 2rem !important;
      @media (max-width: 425px) {
        font-size: 2rem;
      }

    }
    &__subtitle {
      color: #242424;
      font-size: 1.6rem;
      font-weight: 400;
      width: 75%;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 0.5rem !important;
    }
    .non-login-subtitle {
      width: 90%;
      @media (max-width: 425px) {
          width: 80%;
      }
    }
    &--alert {
      padding: 5rem 1rem 4rem !important;
      border-radius: .8rem;

      i {
        color: #242424;
      }
    }
  }
  .modal-btn {
    padding: 1.3rem 2.5rem;
    background: #382246;
    border-radius: 25px;
    font-size: 1.6rem;
    margin-top: 3rem;

    span {
      font-weight: bold;
      font-size: 1.6rem;
      @media (max-width: 425px) {
        font-size: 1.6rem;
      }
    }
    @media (max-width: 425px) {
      width: 90%;
      margin-top: 2rem;
    }
  }
}
</style>
